import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Stepper as Stepper$2, Description, Title, Subtitle, ButtonContainer, Button, Value, SrOnly } from './Stepper.style.js';
import texts from './Stepper.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';
import Icon from '../Icon/Icon.js';
import { ICON_UI_MINUS } from '../../icons/ICON_UI_MINUS.js';
import { ICON_UI_CIRCLE_MINUS } from '../../icons/ICON_UI_CIRCLE_MINUS.js';
import { ICON_UI_ADD } from '../../icons/ICON_UI_ADD.js';
import { ICON_UI_CIRCLE_ADD } from '../../icons/ICON_UI_CIRCLE_ADD.js';

var _excluded = ["minValue", "maxValue", "value", "title", "subtitle", "onChange", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Stepper = function Stepper(_ref) {
  var minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    value = _ref.value,
    title = _ref.title,
    subtitle = _ref.subtitle,
    onChange = _ref.onChange;
    _ref.id;
    var rest = _objectWithoutProperties(_ref, _excluded);
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var isGlobetrotter = useIsGlobetrotter();
  var decreaseLabel = "".concat(texts[culture].decrease, " ").concat(title);
  var increaseLabel = "".concat(texts[culture].increase, " ").concat(title);
  var disabledIncreaseButton = value >= maxValue;
  var disabledDecreaseButton = value <= minValue;
  return /*#__PURE__*/jsxs(Stepper$2, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/jsxs(Description, {
      children: [/*#__PURE__*/jsx(Title, {
        children: title
      }), /*#__PURE__*/jsx(Subtitle, {
        children: subtitle
      })]
    }), /*#__PURE__*/jsxs(ButtonContainer, {
      children: [/*#__PURE__*/jsx(Button, {
        type: "button",
        "aria-label": decreaseLabel,
        onClick: function onClick() {
          return !disabledDecreaseButton && onChange(value - 1);
        },
        "aria-disabled": disabledDecreaseButton,
        $disabled: disabledDecreaseButton,
        children: /*#__PURE__*/jsx(Icon, {
          "aria-hidden": "true",
          path: isGlobetrotter ? ICON_UI_MINUS : ICON_UI_CIRCLE_MINUS
        })
      }), /*#__PURE__*/jsxs(Value, {
        "aria-live": "assertive",
        "aria-atomic": "true",
        children: [/*#__PURE__*/jsx(SrOnly, {
          children: "".concat(title, ": ")
        }), value]
      }), /*#__PURE__*/jsx(Button, {
        type: "button",
        "aria-label": increaseLabel,
        onClick: function onClick() {
          return !disabledIncreaseButton && onChange(value + 1);
        },
        "aria-disabled": disabledIncreaseButton,
        $disabled: disabledIncreaseButton,
        children: /*#__PURE__*/jsx(Icon, {
          "aria-hidden": "true",
          path: isGlobetrotter ? ICON_UI_ADD : ICON_UI_CIRCLE_ADD
        })
      })]
    })]
  }));
};
Stepper.defaultProps = {
  minValue: 0,
  maxValue: 5,
  subtitle: ''
};
var Stepper$1 = Stepper;

export { Stepper$1 as default };
//# sourceMappingURL=Stepper.js.map
